import React, { useState, useEffect } from "react";
import styles from "./CountryNavbar.module.css";
import { useParams } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

function CountryNavbar(props) {
  const login = props.login;

  return (
    <div>
      <div className={styles.navbar}>
        <Link to="/">
          <img src={logo} alt="Logo" className={styles.logo} />
        </Link>
        <div className={styles.navopt}>
          <Link to="/">
            <p className={styles.text}>Home</p>
          </Link>
          <Link to="/">
          <p className={styles.text}>About us</p>
          </Link>
          {login ? (
            <>
              <Link to="/dashboard/home">
                <p className={styles.text}>My Account</p>
              </Link>
              <Link to="/dashboard/my-applications">
              <button className={styles.navbtn}>Check Status</button>
              </Link>
            </>
          ) : (
            <Link to="/login">
              <p className={styles.text}>Login</p>
            </Link>
          )}
        </div>
      </div>

      <div className={styles.secondNav}>
          <h1 className={styles.countryName}>{props.countryName}</h1>
      </div>
    </div>
  );
}

export default CountryNavbar;